import config from '../../config'
import { authHeader } from '../utils/auth-header'

export const playerService = {
  updateOne, deleteOne, insertMany, deleteMany
}

async function updateOne (player) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(player)
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/player/${player._id}`, requestOptions)
  result = await result.json()

  return result
}

async function insertMany (players) {
  for (let player of players) {
    let requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(player)
    }
    requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

    let result = await fetch(`${config.apiUrl}/player`, requestOptions)
    result = await result.json()
  }
  return ''
}

async function deleteOne (playerId) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/player/${playerId}`, requestOptions)
  result = await result.json()

  return result
}

async function deleteMany (playerIds) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  for (let playerId of playerIds) {
    await fetch(`${config.apiUrl}/player/${playerId}`, requestOptions)
  }

  return 'OK'
}



// WEBPACK FOOTER //
// ./src/services/player.js